import Cookies from 'js-cookie';
import { memo, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { FEHeadersCookiesUtil } from 'utils';

export const AdmitadScript = memo(
  ({
    price,
    items,
    orderNumber,
    order_id
  }: {
    price: string | null;
    items:
      | {
          Product: {
            productID: string;
            category: '1';
            price: string;
            priceCurrency: 'RUB' | 'AED';
          };
          orderQuantity: number;
          additionalType: 'sale';
        }[]
      | null;
    orderNumber: string | null;
    order_id: string | null
  }) => {
    const [show, setShow] = useState(false);
    useEffect(() => {
      //@ts-ignore
      window.admitadTempVars = {
        price,
        items,
        orderNumber,
      };
      setShow(true);
      return () => {
        //@ts-ignore
        delete window.admitadTempVars;
        setShow(false);
      };
    }, [price, items, orderNumber]);

    useEffect(() => {
      const a_utm_source = Cookies.get('a_utm_source');
  
      // Проверяем, что последний платный источник - Admitad и у нас есть UID
      if (a_utm_source === 'admitad') {
        // Собираем URL для postback-запроса
        const postbackUrl = new URL('https://ad.admitad.com/r');
  
        const params: Record<string, any> = {
          campaign_code: '9fd01c3e9f',
          postback: '1',
          postback_key: '25508A5b49099F75E6129eDA90A893B6',
          action_code: '1', // Оплаченный заказ
          tariff_code: '1', // Тариф по умолчанию
          payment_type: 'sale',
          currency_code: 'RUB', // !!! Укажите вашу валюту по ISO 4217
          uid: FEHeadersCookiesUtil.getAdmintaduid(),
          order_id: order_id,
          price: price
        };
  
        Object.keys(params).forEach(key => postbackUrl.searchParams.append(key, params[key]));
  
        
  
        if (navigator.sendBeacon) {
          navigator.sendBeacon(postbackUrl.href);          
      } else {
          // Резервный вариант для очень старых браузеров
          fetch(postbackUrl.href, { method: 'GET', mode: 'no-cors', keepalive: true });
      }
      }
    }, []);

    return show ? (
      <Helmet>
        <script type='text/javascript'>{`
              ADMITAD = window.ADMITAD || {};
              ADMITAD.Invoice = ADMITAD.Invoice || {};
              if (!getSourceCookie(cookie_name)) {
                ADMITAD.Invoice.broker = 'na';
              } else if (getSourceCookie(cookie_name) != deduplication_cookie_value) {
                ADMITAD.Invoice.broker = getSourceCookie(cookie_name);
              } else {
                ADMITAD.Invoice.broker = 'adm';
              }
              ADMITAD.Invoice.category = '1';
              var orderedItem = window.admitadTempVars.items;
              ADMITAD.Invoice.referencesOrder = ADMITAD.Invoice.referencesOrder || [];
              ADMITAD.Invoice.referencesOrder.push({
                orderNumber: window.admitadTempVars.orderNumber,
                orderedItem: orderedItem,
              });
              ADMITAD.Tracking?.processPositions();
          `}</script>
      </Helmet>
    ) : (
      <></>
    );
  },
);
